module.exports = __webpack_public_path__ + "media/images/doctor-day/doctorday-template-ro-198a0cc3bda18eaa27fb29a9391d12b3.png";